import {
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
// import { CircleIcon, SquareIcon, VercelLogoIcon } from '@radix-ui/react-icons';
import { FullScreenIcon, NoteIcon } from '@sketchnote/icons';
import { CircleIcon } from '@sketchnote/icons';
import * as React from 'react';
import {
  ColorStyle,
  fills,
  Panel,
  StyledRow,
  TDShapeType,
  TDSnapshot,
  TDToolType,
  Theme,
  ToolButton,
  ToolButtonWithTooltip,
  Tooltip,
  useTldrawApp,
} from 'sn-wb-tldraw';
import { Utils } from 'sn-wb-tldraw-core';

import { ColorMenu } from './ColorMenu';
import { colors } from './ColorMenu';
interface ShapesMenuProps {
  activeTool: TDToolType;
  isToolLocked: boolean;
}

export const stickyColors = {
  [ColorStyle.Green]: 'rgb(147, 210, 117)',
  [ColorStyle.Blue]: 'rgb(108, 216, 250)',
  [ColorStyle.Pink]: 'rgb(255, 206, 224)',
  [ColorStyle.Violet]: 'rgb(123, 146, 255)',
  [ColorStyle.Red]: 'rgb(241, 108, 127)',
  [ColorStyle.Orange]: 'rgb(255, 157, 72)',
  [ColorStyle.Yellow]: 'rgb(245, 209, 40)',
};

type ShapeShape = TDShapeType.Sticky;

const shapeShapes: ShapeShape[] = [TDShapeType.Sticky];

const currentStyleSelector = (s: TDSnapshot) => s.appState.currentStickyStyle;

const canvasLight = '#fafafa';

const canvasDark = '#343d45';

const statusSelector = (s: TDSnapshot) => s.appState.status;

enum Status {
  SpacePanning = 'spacePanning',
}

export const NoteMenu = React.memo(function ShapesMenu({
  activeTool,
  isToolLocked,
}: ShapesMenuProps) {
  const app = useTldrawApp();

  const status = app.useStore(statusSelector);
  const currentStyle = app.useStore(currentStyleSelector);
  const [isHovered, setHovered] = React.useState<boolean>(false);
  const [displayedStyle, setDisplayedStyle] = React.useState(currentStyle);
  const [isOpen, setOpen] = React.useState<boolean>(false);

  const [lastActiveTool, setLastActiveTool] = React.useState<ShapeShape>(TDShapeType.Sticky);

  const isSmallScreen = window.innerHeight < 800;

  const offset = isSmallScreen ? -27 : -58;
  const sideOffset = isSmallScreen ? 24 : 34;

  React.useEffect(() => {
    if (shapeShapes.includes(activeTool as ShapeShape) && lastActiveTool !== activeTool) {
      setLastActiveTool(activeTool as ShapeShape);
    }
  }, [activeTool]);

  const selectShapeTool = React.useCallback(() => {
    app.selectTool(lastActiveTool);
  }, [activeTool, app]);

  const handleDoubleClick = React.useCallback(() => {
    app.toggleToolLock();
  }, [app]);

  const handleKeyDown = React.useCallback((e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === ' ') {
      if (app.shiftKey) {
        e.preventDefault();
      }
    }
  }, []);

  const isActive = shapeShapes.includes(activeTool as ShapeShape);

  return (
    <Menu direction="ltr" isLazy offset={[offset, sideOffset]} placement="right">
      <div
        className={`overflow-hidden h-62 w-80 smallScreen:h-48 smallScreen:w-48 flex justify-center  hover:bg-gray-199 relative ${
          isActive && 'bg-gray-199'
        }`}
        style={{ borderBottom: '1px solid #F6F7F9' }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Tooltip
          id="Sticker"
          label={lastActiveTool[0].toUpperCase() + lastActiveTool.slice(1)}
          side="right"
        >
          <MenuButton
            disabled={isActive && app.shiftKey} // otherwise this continuously opens and closes on "SpacePanning"
            onDoubleClick={handleDoubleClick}
            onClick={() => {
              app.selectTool(TDShapeType.Sticky);
            }}
            className={`mx-auto py-4 transform scale-135 smallScreen:scale-100 -translate-x-8 smallScreen:translate-x-0  ${
              isActive ? '-translate-x-12 smallScreen:-translate-x-3 rotate-15' : 'translate-y-4'
            }  hover:-translate-x-12 smallScreen:hover:-translate-x-3 hover:rotate-15 origin-top-left duration-100 ease-in-out`}
            // isToolLocked={isActive && isToolLocked}
            // isActive={isActive}
            onKeyDown={handleKeyDown}
          >
            <NoteIcon fill={stickyColors[currentStyle.color] || 'rgb(255, 206, 224)'} />
          </MenuButton>
        </Tooltip>

        <div
          className={`absolute right-14 smallScreen:right-5  bottom-0 opacity-0 translate-x-0 transition-all duration-100 ease-in-out ${
            isHovered ? 'transform opacity-100  translate-x-4' : ''
          }`}
        >
          <FullScreenIcon />
        </div>
      </div>

      <MenuList>
        <Panel
          side="center"
          style={{
            padding: '5px 0',
            boxShadow: '0px 4px 4px rgba(135, 138, 146, 0.15)',
            border: '1px solid #E2E4E9',
            borderRadius: `${isSmallScreen ? '9px' : '14px'}`,
          }}
          className="w-57 smallScreen:w-37"
        >
          <div className="flex justify-center items-center flex-col gap-2 smallScreen:gap-0 py-5 smallScreen:py-0">
            {Object.keys(stickyColors).map((style: string, i) => (
              <div
                key={style}
                className="h-27 w-27 flex justify-center items-center transform smallScreen:scale-70 smallScreen:hover:scale-90 hover:scale-110 duration-75 ease-in-out "
              >
                <MenuItem style={{ justifyContent: 'center' }}>
                  <div
                    // kbd={(4 + i).toString()}
                    onClick={() => app.style({ color: style as ColorStyle })}
                  >
                    <CircleIcon
                      fill={stickyColors[style]}
                      wrapperClass="flex cursor-pointer justify-center items-center py-3 smallScreen:py-1"
                    />
                  </div>
                </MenuItem>
              </div>
            ))}
          </div>
        </Panel>
      </MenuList>
    </Menu>
  );
});
